<template>
  <BModal
    id="modal-confirm-update-log"
    ref="modal-confirm-update-log"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="d-flex justify-content-end">
      <button
        class="btn p-0"
        @click="$bvModal.hide('modal-confirm-update-log')"
      >
        <feather-icon
          icon="XIcon"
          size="20"
          class="text-black"
        />
      </button>
    </div>
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
        alt="Warning"
        class="m-auto"
        style="max-width: 120px;"
      >
    </div>
    <h4 class="text-black text-center font-bold mt-1">
      {{ title }}
    </h4>
    <p class="text-center text-[#828282] my-1 px-2">
      {{ description }}
    </p>
    <BRow class="flex justify-center mb-2 px-2">
      <BCol>
        <BButton
          class="rounded-lg"
          variant="outline-primary"
          block
          @click="$bvModal.hide('modal-confirm-update-log')"
        >
          Batal
        </BButton>
      </BCol>
      <BCol>
        <BButton
          class="rounded-lg"
          :variant="loading ? 'secondary' : 'primary'"
          :disabled="loading"
          block
          @click="onConfirm"
        >
          <BSpinner
            v-if="loading"
            variant="light"
            small
            class="mr-1"
          />
          {{ confirmText }}
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Publish Update Log?',
    },
    description: {
      type: String,
      default: 'Setelah dipublikasikan, update log akan tersedia untuk seluruh pengguna',
    },
    confirmText: {
      type: String,
      default: 'Lanjut Publish',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
